module.exports = __webpack_public_path__ + "img/full7-min.5505e456.png";